<template>
  <view class="pft-data-text-2-component" flex="dir:top main:center cross:stretch" :style="style">
    <view class="text-data" flex="dir:left main:center cross:center">
      <template v-if="componentLoading">
        <Loading />
      </template>
      <template v-else>
        <view flex="dis:left cross:bottom">
          <view class="data-val" :style="dataStyle">
            {{ formatData(dataVal || data) }}
          </view>
          <view class="data-suffix" v-if="suffix">{{ suffix }}</view>
          <view class="data-percent" v-if="percent">{{ percent }}</view>
        </view>

        <!-- <template v-if="/\d+/.test(data) === false">{{ data }}</template>
          <template v-else>
            <DigitalFlop :config="{ number: [Number(data)], content: '{nt}' }" />
          </template> -->
      </template>
    </view>
    <view class="seperate" flex="dir:left main:center">
      <view class="seperate-block"></view>
    </view>
    <view class="text-title" :style="titleStyle">{{ title }}</view>
  </view>
</template>
<script lang="ts" setup>
import { ref } from "vue"
import Loading from "@p-v/packages/Loading.vue"
import numeral from "numeral"

interface DataTextProps {
  title: string
  data: string
  format?: string | ((data: string | number) => string)
  suffix?: string
  style?: { [key: string]: string }
  titleStyle?: { [key: string]: string }
  dataStyle?: { [key: string]: string }
  empty: string | undefined
}

const props = withDefaults(defineProps<DataTextProps>(), {
  title: () => "",
  data: () => "",
  suffix: undefined,
  format: () => "0,0",
  style: () => ({}),
  titleStyle: () => ({}),
  dataStyle: () => ({}),
  empty: undefined,
})

const formatData = (val: string | number) => {
  if (val === undefined || val === null || val == 0) {
    if (props.empty) return props.empty
    if (val == 0) {
      if (typeof props.format === "function") {
        return props.format(val)
      }
      return numeral(Number(val)).format(props.format)
    } else {
      return ""
    }
  }
  if (typeof val === "string" && /\d+/.test(val) === false) {
    return val
  }
  if (typeof props.format === "function") {
    return props.format(val)
  }
  return numeral(Number(val)).format(props.format)
}

const componentLoading = ref<boolean>(true)

const dataVal = ref<string | number>("")
const percent = ref<number>(0)

const loading = () => {
  componentLoading.value = true
}

const setData = (val: string | number | { val: string | number; rate: number }, rate?: number) => {
  componentLoading.value = false
  if (typeof val === "object") {
    dataVal.value = val.val
    percent.value = val.rate
  } else if (typeof val === "string" || typeof val === "number") {
    dataVal.value = val
    percent.value = rate || 0
  }
}

defineExpose({ loading, setData })
</script>
<style lang="scss">
.pft-data-text-2-component {
  box-sizing: border-box;
  .text-title {
    background: rgba(186, 231, 255, 0.1);
    font-family:
      Segoe UI,
      Segoe UI;
    font-weight: 400;
    font-size: 14px;
    color: rgba(230, 247, 255, 0.75);
    line-height: 36px;
    text-align: center;
    width: 100%;
  }
  .text-data {
    height: 57px;
    background: rgba(186, 231, 255, 0.1);
    width: 100%;
    .data-val {
      font-family:
        "Segoe UI",
        Segoe UI;
      font-weight: bold;
      font-size: 28px;
      color: #2bb7f7;
      line-height: 33px;
    }
    .data-suffix {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: 400;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.65);
      margin-left: 2px;
    }
    .data-percent {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: 400;
      font-size: 12px;
      color: #fcf072;
      margin-left: 8px;
    }
  }
  .seperate-block {
    width: 18px;
    height: 4px;
    background: #4cb7ff;
    display: block;
  }
}
</style>
